module.exports = __webpack_public_path__ + "static/AnnAustin-60606e65843f6154d79f79ddaed7436d.jpg";